import { render, staticRenderFns } from "./SearchResultsCard.vue?vue&type=template&id=473ec711&"
import script from "./SearchResultsCard.vue?vue&type=script&lang=ts&"
export * from "./SearchResultsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports